module.exports = __webpack_public_path__ + "img/pi3ckrightsection.90b92147.png";